import React from "react";
import { size } from "lodash";
import { IllustrationProps } from ".";

export default ({
  colors: {
    base,
    scheme,
    chart: { primary },
  },
  options: { normalized },
}: IllustrationProps) => {
  const numberOfColors = size(scheme);
  const _scheme =
    numberOfColors === 0
      ? [primary, base]
      : numberOfColors === 1
      ? [...scheme, base]
      : scheme;

  return (
    <svg width="100%" height="100%" viewBox="0 0 432 120">
      {normalized ? (
        <>
          <g fill={_scheme[0]}>
            <rect width="32" height="56" y="64" />
            <rect width="32" height="87" x="160" y="33" />
            <rect width="32" height="64" x="320" y="56" />
            <rect width="32" height="82" x="80" y="38" />
            <rect width="32" height="73" x="240" y="47" />
            <rect width="32" height="65" x="40" y="55" />
            <rect width="32" height="77" x="200" y="43" />
            <rect width="32" height="80" x="360" y="40" />
            <rect width="32" height="79" x="120" y="41" />
            <rect width="32" height="78" x="280" y="42" />
            <rect width="32" height="81" x="400" y="39" />
          </g>
          <g fill={_scheme[1]}>
            <rect width="32" height="28" y="37" />
            <rect width="32" height="41" x="320" y="16" />
            <rect width="32" height="33" x="40" y="22.81" />
            <rect width="32" height="28" x="240" y="20" />
            <rect width="32" height="13" x="200" y="31" />
            <rect width="32" height="29" x="280" y="14" />
            <rect width="32" height="14" x="120" y="28" />
            <rect width="32" height="13" x="360" y="28" />
            <rect width="32" height="19" x="400" y="21" />
            <rect width="32" height="15" x="80" y="24" />
            <rect width="32" height="12" x="160" y="22" />
          </g>
          <g fill={_scheme[2] || _scheme[1]}>
            <rect width="32" height="20" y="18" />
            <rect width="32" height="8" x="200" y="24" />
            <rect width="32" height="13" x="80" y="12" />
            <rect width="32" height="28" x="360" y="1" />
            <rect width="32" height="12" x="120" y="17" />
            <rect width="32" height="5" x="40" y="19" />
            <rect width="32" height="11" x="160" y="12" />
            <rect width="32" height="5" x="400" y="17" />
            <rect width="32" height="9" x="240" y="12" />
            <rect width="32" height="8" x="280" y="7" />
            <rect width="32" height="15" x="320" y="2" />
          </g>
          <g fill={_scheme[3] || _scheme[1]}>
            <rect width="32" height="25" x="200" />
            <rect width="32" height="20" x="40" />
            <rect width="32" height="19" />
            <rect width="32" height="18" x="120" />
            <rect width="32" height="18" x="400" />
            <rect width="32" height="13" x="80" />
            <rect width="32" height="13" x="160" />
            <rect width="32" height="13" x="240" />
            <rect width="32" height="8" x="280" />
            <rect width="32" height="2" x="360" />
            <rect width="32" height="3" x="320" />
          </g>
        </>
      ) : (
        <>
          <g fill={_scheme[0]}>
            <rect width="32" height="31" y="89" />
            <rect width="32" height="46" x="320" y="74" />
            <rect width="32" height="46" x="40" y="74" />
            <rect width="32" height="47" x="360" y="73" />
            <rect width="32" height="53" x="200" y="67" />
            <rect width="32" height="58" x="240" y="62" />
            <rect width="32" height="69" x="280" y="51" />
            <rect width="32" height="71.96" x="80" y="48" />
            <rect width="32" height="71" x="400" y="49" />
            <rect width="32" height="79" x="160" y="41" />
            <rect width="32" height="80.83" x="120" y="39" />
          </g>
          <g fill={_scheme[1]}>
            <rect width="32" height="17" y="73" />
            <rect width="32" height="28" x="320" y="47" />
            <rect width="32" height="24" x="40" y="51" />
            <rect width="32" height="8" x="360" y="66" />
            <rect width="32" height="8" x="200" y="60" />
            <rect width="32" height="22" x="240" y="41" />
            <rect width="32" height="25" x="280" y="27" />
            <rect width="32" height="13" x="80" y="36" />
            <rect width="32" height="17" x="400" y="33" />
            <rect width="32" height="13" x="160" y="29" />
            <rect width="32" height="13" x="120" y="27" />
          </g>
          <g fill={_scheme[2] || _scheme[1]}>
            <rect width="32" height="11" y="63" />
            <rect width="32" height="16" x="360" y="51" />
            <rect width="32" height="4" x="200" y="57" />
            <rect width="32" height="3" x="40" y="49" />
            <rect width="32" height="6" x="320" y="42" />
            <rect width="32" height="7" x="240" y="35" />
            <rect width="32" height="11" x="80" y="26" />
            <rect width="32" height="3" x="400" y="31" />
            <rect width="32" height="11" x="160" y="19" />
            <rect width="32" height="5" x="280" y="23" />
            <rect width="32" height="12" x="120" y="16" />
          </g>

          <g fill={_scheme[3] || _scheme[1]}>
            <rect width="32" height="9" y="55" />
            <rect width="32" height="18" x="200" y="40" />
            <rect width="32" height="5" x="360" y="47" />
            <rect width="32" height="12" x="40" y="38" />
            <rect width="32" height="5" x="320" y="38" />
            <rect width="32" height="12" x="240" y="24" />
            <rect width="32" height="15" x="400" y="17" />
            <rect width="32" height="11" x="80" y="16" />
            <rect width="32" height="8" x="280" y="16" />
            <rect width="32" height="12" x="160" y="8" />
            <rect width="32" height="17" x="120" />
          </g>
        </>
      )}
    </svg>
  );
};
